import { apiMutate } from 'service/utils/mutation';
import { useDeliveryZoneMsToken } from 'hooks';
import { UpdateDeliveryZonePayload, UpdateDeliveryZoneInput } from '../../types/generated';
import { updateDeliveryZoneMutation } from '../../mutations';

type useUpdateDeliveryZoneType = () => ({
  input,
}: {
  input?: UpdateDeliveryZoneInput;
}) => Promise<void | Partial<UpdateDeliveryZonePayload> | { hasError: boolean }>;

const useUpdateDeliveryZone: useUpdateDeliveryZoneType = () => {
  const deliveryZoneMsToken = useDeliveryZoneMsToken();

  return input =>
    apiMutate({
      mutation: updateDeliveryZoneMutation,
      variables: { input },
      requestHeaders: { token: deliveryZoneMsToken },
      handler: (res: any) => res?.updateDeliveryZone,
    });
};

export default useUpdateDeliveryZone;
